export default __webpack_public_path__ + "static/media/ibetologotext.cce4497e.svg";